<template>
    <div class="container">
        <van-nav-bar leftText leftArrow @click-left="backGo" class="query-header headerbar">
            <div class="bh bstart query-title" slot="title">
                <van-field
                    v-model="queryText"
                    class="input-query"
                    clearable
                    maxlength="20"
                    placeholder="请输入关键词查询"
                >
                    <div slot="right-icon" class="ico-query bg-contain"></div>
                </van-field>
            </div>
            <van-button @click="onQueryClick" class="btn btn-text" slot="right">
                <div class="fz_30">搜索</div>
            </van-button>
        </van-nav-bar>
        <div class="topbar-container">
            <div class="line"></div>
            <GroupButton
                title="历史搜索"
                :data="historyData.data"
                :isDel="true"
                @delClick="onDelClick"
                @btnClick="onBtnClick"
                v-show="historyData.data.length"
            ></GroupButton>
            <GroupButton title="热门搜索" :data="store.data" @btnClick="onBtnClick"></GroupButton>
        </div>
    </div>
</template>

<script>
import GroupButton from "@/components/btn/Group";
import { list } from "@/mixin/list";
import { routeCache } from "@/mixin/cache";
import { hotList } from "@/api/car";
import cache from "@/utils/cache";

export default {
    mixins: [list, routeCache],
    name: "CarGoodsQuery",
    components: { GroupButton },
    data() {
        return {
            // 热门搜索
            store: {
                proxy: {
                    getList: hotList,
                    pageSize: 6,
                    limitParam: "num"
                }
            },
            queryText: "",
            // 是否来至首页
            isHome: false,
            historyData: {
                data: [],
                key: "goodsHistory"
            }
        };
    },
    created() {
        const me = this;
        me.storeLoad();
        cache.load(me.historyData);
        me.isHome = me.getCache().isHome;
    },
    methods: {
        onDelClick() {
            this.dialog
                .confirm({
                    title: "提示",
                    message: "确定删除全部历史记录？"
                })
                .then(() => {
                    cache.removeAll(this.historyData);
                });
        },
        onBtnClick(item) {
            const me = this;
            cache.push(me.historyData, item);
            me.$store.state.queryParams = item.name;
            // 如果是从首页进入的搜索页面
            if (me.isHome) {
                me.$router.replace({ name: "CarGoodsHome" });
            } else {
                me.$router.go(-1);
            }
        },
        onQueryClick() {
            const me = this;
            if (me.queryText) {
                me.onBtnClick({
                    name: me.queryText
                });
            } else {
                me.toast.fail("请输入查询内容");
            }
        }
    }
};
</script>

<style scoped lang="scss">
.line {
    background: rgba(241, 242, 243, 1);
}
.container {
    background: #fff;
    .ico-query {
        width: 36px;
        height: 36px;
        margin-right: 0;
    }
}
</style>

